module.exports = __webpack_public_path__ + "static/media/flowers.b458aa2c.png";